// frontend/src/modules/router/onboarding.js
const route = {
    path: '/onboarding',
    meta: { authClass: 'onboarding' },
    children: [
        { path: 'konto', meta: { authClass: 'public', step: 1 },
          components: { default: () => import(/* webpackChunkName: "onboarding" */ '../../components/views/onboarding/RegisterStep.vue') } },
        { path: 'plan', meta: { authClass: 'onboarding', step: 3 },
          components: { default: () => import(/* webpackChunkName: "onboarding" */ '../../components/views/onboarding/PlanStep.vue') } },
        { path: 'fertig', meta: { authClass: 'onboarding', step: 4 },
          components: { default: () => import(/* webpackChunkName: "onboarding" */ '../../components/views/onboarding/CheckoutResultStep.vue') } },
    ],
};
module.exports = route;
